import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MiscSvgComponent } from '@curbnturf/custom-svgs/src/lib/misc-svg/misc-svg.component';
import { TrailerSvgLineComponent } from '@curbnturf/custom-svgs/src/lib/trailer-svg-line/trailer-svg-line.component';
import { DisplayValidationErrorsDirective, IVehiclesForm, ToggleComponent } from '@curbnturf/form-helpers';

@Component({
  selector: 'curbnturf-listing-rvs',
  templateUrl: './listing-rvs.component.html',
  styleUrls: ['./listing-rvs.component.scss'],
  standalone: true,
  imports: [
    DisplayValidationErrorsDirective,
    FormsModule,
    MiscSvgComponent,
    NgIf,
    ReactiveFormsModule,
    ToggleComponent,
    TrailerSvgLineComponent,
  ],
})
export class ListingRvsComponent {
  @Input() vehiclesForm: FormGroup<IVehiclesForm>;

  selected(type: string): boolean {
    if (!this.vehiclesForm) {
      return true;
    }

    const typeInput = this.vehiclesForm.get(type);
    return typeInput ? typeInput.value : false;
  }

  allSelected(): boolean {
    return this.selectedCount() === 8;
  }

  selectAll() {
    let newValue = true;

    if (this.allSelected()) {
      newValue = false;
    }

    const vehicles = this.vehiclesForm.value;
    Object.keys(vehicles).forEach((vehicleType) => {
      const vehicleForm = this.vehiclesForm.get(vehicleType);
      if (vehicleForm) {
        vehicleForm.setValue(newValue);
      }
    });
    this.vehiclesForm.markAsDirty();
  }

  private selectedCount(): number {
    const vehicles: any = this.vehiclesForm.value;
    return Object.keys(vehicles).reduce((count, vehicleType) => {
      if (vehicles[vehicleType]) {
        count += 1;
      }

      return count;
    }, 0);
  }

  selectNone() {
    let newValue = false;

    if (this.allSelected()) {
      newValue = true;
    }

    const vehicles = this.vehiclesForm.value;
    Object.keys(vehicles).forEach((vehicleType) => {
      const vehicleForm = this.vehiclesForm.get(vehicleType);
      if (vehicleForm) {
        vehicleForm.setValue(newValue);
      }
    });
    this.vehiclesForm.markAsDirty();
  }

  tentOnly() {
    return this.selectedCount() === 0;
  }
}
